import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetChargingPileExceptionByPage(params) {
  let url = `/device/maintenanceMan/chargingPileException/getChargingPileExceptionByPage`;

  if (params.checkList && Array.isArray(params.checkList)) {
    for (let i = 0; i < params.checkList.length; i++) {
      const item = params.checkList[i];
      url += i == 0 ? `?type=${item}` : `&type=${item}`;
    }
  }

  delete params.checkList;

  return maintainRequest({
    url,
    params: params,
  });
}
